import FavoriteIcon from '@mui/icons-material/Favorite';
import { Box, Card, Grid, Text, styled } from '@/theme/index';
import { capitalizeString } from '@/utils/capitalizeString';

export const StyledSubtitleDetails = styled(Text)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const StyledDetailsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  marginTop: theme.spacing(2),
}));

export const StyledDetailsSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const StyledBoxService = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(1.5),
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.secondary.light}`,
  boxShadow: 'none',
  marginBottom: 0,
  height: '100%',
  boxSizing: 'border-box',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2),
  },
}));

export const StyledBoxServiceTop = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'start',
  gap: theme.spacing(2),
  alignSelf: 'stretch',
}));

export const StyledCaledarService = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: `
      ${theme.spacing(1.5)} 
      ${theme.spacing(1)} 
      ${theme.spacing(1)} 
      ${theme.spacing(1)}
    `,
  alignItems: 'center',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.secondary.light}`,
  background: theme.palette.background.paper,
  minWidth: '81px',
}));

export const StyledCalendarDay = styled(Text)(() => ({
  fontSize: '2.125rem',
  margin: 0,
}));

export const StyledServicedTypeContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.25),
}));

export const StyledLocationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
}));

export const StyledImg = styled('img')(() => ({
  width: '52px',
  height: '50px',
}));

export const StyledBoxDonation = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(1.5),
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.secondary.light}`,
  boxShadow: 'none',
  marginBottom: 0,
  textAlign: 'center',
  height: '100%',
  boxSizing: 'border-box',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2.5),
  },
}));

export const StyledNoNoFoundDetailsContainer = styled(Box)(({ theme }) => ({
  padding: '12px',
  backgroundColor: theme.palette.background.default,
  textAlign: 'center',
  width: '100%',
}));

export const StyledDonationIcon = styled(Box)({
  background: '#E2DFFF',
  borderRadius: '100%',
  width: '52px',
  height: '50px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: 'auto',
});

export const DonationCard = ({ charityName }: { charityName: string }) => {
  return (
    <Grid item xs={6} sm={3}>
      <StyledBoxDonation>
        <StyledDonationIcon>
          <FavoriteIcon color="primary" />
        </StyledDonationIcon>
        <Text variant="h5" sx={{ marginTop: '12px' }}>
          {capitalizeString(charityName)}
        </Text>
      </StyledBoxDonation>
    </Grid>
  );
};
